<template>
  <div>
    <DocumentsFile
      v-for="(file, index) in files"
      :key="index"
      :file="file"
    />
  </div>
</template>

<script>
import files from '../../services/personnelFiles'
import DocumentsFile from '@/components/Documents/DocumentsFile'

export default {
  name: 'InvestigationPerimeter',

  components: {
    DocumentsFile,
  },

  data() {
    return {
      files,
    }
  },
}
</script>

<style lang="postcss" scoped>
</style>
